/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { InitialOasisAssessmentValuesViewModel } from './InitialOasisAssessmentValuesViewModel'; 

export function getOasisAssessmentValuesForQuestionOptions(id: string, oasisQuestionName: string, onSuccess?: (result: InitialOasisAssessmentValuesViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-assessment-values-for-question', id, oasisQuestionName],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getoasisassessmentvaluesforquestion/' + id + '/' + oasisQuestionName;
			const resp = await axios.get<InitialOasisAssessmentValuesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id) && Boolean(oasisQuestionName)
	});
}